import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, HttpClientModule } from '@angular/common/http'; // Ensure this is imported
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { BootstrapeModule } from '../bootstrape/bootstrape.module';
import { CkeditorComponent } from './ckeditor/ckeditor.component';

@NgModule({
  declarations: [
    CkeditorComponent
  ],
  imports: [
    CommonModule,
   
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
    HttpClientModule,
   
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
    HttpClientModule,
    CkeditorComponent
  ],
  providers: [provideHttpClient()],
})
export class SharedModule { }
